import React from "react";
import { setTransactionsView } from "@actions";
import RefreshButton from "@buttons/RefreshButton";
import { connect } from "react-redux";
import { Checkbox, Form } from "semantic-ui-react";
import DateTimeGroupInput from "./DateTimeGroupInput";

const DatePeriodFilters = (props) => {
  const { onChange } = props;
  const { hasSelection } = props.filters;
  const { useCurrentDateTime, searchParams } = props.view;
  const { startDate, endDate } = searchParams;

  return (
    <>
      <Form.Group>
        <DateTimeGroupInput
          label="From"
          name="startDate"
          datetime={startDate}
          onChange={onChange}
          disabled={!hasSelection}
        />
      </Form.Group>
      <Form.Group>
        <DateTimeGroupInput
          label="To"
          name="endDate"
          datetime={endDate}
          onChange={onChange}
          disabled={!hasSelection || useCurrentDateTime}
        />
        <Checkbox
          checked={useCurrentDateTime}
          label="Current Time/Date"
          onChange={() =>
            props.setTransactionsView({
              useCurrentDateTime: !useCurrentDateTime,
            })
          }
          disabled={!hasSelection}
        />
        <RefreshButton
          className="ml-1"
          refresh={props.refresh}
          disabled={!hasSelection}
        />
      </Form.Group>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    logIn: state.logIn,
    filters: state.transactionsFilters,
    view: state.transactionsView,
  };
};

export default connect(mapStateToProps, { setTransactionsView })(
  DatePeriodFilters,
);
